module.exports = __webpack_public_path__ + "static/img/1.58b24de5.jpg";